import { Box, Breadcrumbs, Card, CardContent, CardMedia, Container, CssBaseline, Grid, Link, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import TopHeader from '../../../../../components/general/TopHeader';
import { Nav, Tab, Tabs } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import { PvMonitoringContext } from '../../../../../context/PvMonitoringContext';
import { PASS_KEY, WEB_KEY } from '../../../../../api/AxiosApi';

import BatteryTab1 from './BatteryTab1/BatteryTab1';
import BatteryTab2 from './BatteryTab1/BatteryTab2';


export default function BatteryTabs({ ID, TabTitle }) {
    const { palette, typography, breakpoints, spacing } = useTheme()
    const matches = useMediaQuery(breakpoints.up('lg'));
    // const [FromDate, setFromDate] = useState(getDateTimeForTab3().LastDay)
    // const [ToDate, setToDate] = useState(getDateTimeForTab3().Today)

    const [key, setKey] = useState('Chart');
    const location = useLocation();
    function handleClick(event) {
        event.preventDefault();
        // console.info('You clicked a breadcrumb.');
    }

    return (
        <Box>
            
            <Box mt={spacing(1)}>
                
                <Tabs
                    style={{ justifyContent: "flex-start" }}
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                >
                    
                    <Tab eventKey="Chart" title="Chart">
                      <BatteryTab1  TabTitle={TabTitle} ID={ID}/>
                    </Tab>

                    <Tab eventKey="Log" title="Log">
                      <BatteryTab2  TabTitle={TabTitle} ID={ID}/>
                    </Tab>

                </Tabs>
            </Box>
        </Box>

    )
}